import {
  Empreendimento,
  ObjectProps,
  User,
  UserData,
} from '../Contexts/AuthContext.type';
import { IAcompanhamentoObra } from '../util/acompanhamentoDeObra';
import { IBuscaBoletos } from '../util/buscaBoletos';
import { IBuscaBoletos as IBuscaBoletosVencidos } from '../util/buscaBoletosVencidos';
import { IBuscaBoletosAvulsos } from '../util/buscaBoletosAvulsos';
import {
  IDownloadContratos,
  IDownloadDocumentos,
} from '../util/downloadDocumentos';
import { IBuscaParcela } from '../util/fichaFinanceira';
import { IBuscaIndices } from '../util/buscaIndices';
import { IBuscaUnidade } from '../util/buscaClienteSubunidade';
import { mockScenario } from './scenario';

export const mockToken = 'mock-access-token';

const mockUsers: User[] = [
  {
    id: 1,
    nome: 'Cliente Demo',
    email: 'demo@soter.com.br',
    senha: '',
    codcfo: '1001',
    codcolcfo: '1',
    ip: '127.0.0.1',
    primeiroAcesso: false,
    tokenGen: mockToken,
    acessoAdministrativo: false,
  },
  {
    id: 2,
    nome: 'Cliente Perfil 2',
    email: 'demo@soter.com.br',
    senha: '',
    codcfo: '1002',
    codcolcfo: '1',
    ip: '127.0.0.1',
    primeiroAcesso: false,
    tokenGen: mockToken,
    acessoAdministrativo: false,
  },
];

export const getMockUsers = (): User[] =>
  mockScenario === 'single-user' ? [mockUsers[0]] : mockUsers;

export const mockUserDataByCfo: Record<string, UserData> = {
  '1001': {
    categoria: 'Cliente',
    nome: 'Cliente Demo',
    nomefantasia: '',
    dataNascimento: '1990-01-10T00:00:00',
    cpf: '123.456.789-00',
    cnpj: '',
    estadoCivil: 'Solteiro(a)',
    identidade: 'MG1234567',
    orgaoEmissor: 'SSP',
    ufEmissor: 'MG',
    nacionalidade: 'Brasileira',
    cep: '30110-000',
    logradouro: 'Rua Exemplo',
    numero: 100,
    complemento: 0,
    bairro: 'Centro',
    cidade: 'Belo Horizonte',
    uf: 'MG',
    pais: 'Brasil',
    telefoneResidencial: '(31) 3333-3333',
    telefoneCelular: '(31) 99999-9999',
    telefoneComercial: '(31) 3222-2222',
    email: 'demo@soter.com.br',
    obs: null,
  },
  '1002': {
    categoria: 'Cliente',
    nome: 'Cliente Perfil 2',
    nomefantasia: '',
    dataNascimento: '1992-04-20T00:00:00',
    cpf: '987.654.321-00',
    cnpj: '',
    estadoCivil: 'Casado(a)',
    identidade: 'MG7654321',
    orgaoEmissor: 'SSP',
    ufEmissor: 'MG',
    nacionalidade: 'Brasileira',
    cep: '30140-000',
    logradouro: 'Av. Exemplo',
    numero: 200,
    complemento: 12,
    bairro: 'Funcionarios',
    cidade: 'Belo Horizonte',
    uf: 'MG',
    pais: 'Brasil',
    telefoneResidencial: '(31) 3555-5555',
    telefoneCelular: '(31) 98888-8888',
    telefoneComercial: '(31) 3666-6666',
    email: 'demo@soter.com.br',
    obs: null,
  },
};

export const mockFunctionalities: ObjectProps[] = [
  101, 102, 103, 104, 105, 106, 107, 108, 109,
].map((id) => ({
  id,
  id_empreendimento: 1,
  descricao: `Funcionalidade ${id}`,
  acessa: true,
}));

export const mockUnits: IBuscaUnidade = [
  {
    nomeEmpreendimento: 'Residencial Aurora',
    codEmpreendimento: 'EMP001',
    idEmpreendimento: 1,
    codUnidade: 'B1',
    unidade: 'Bloco A',
    subUnidade: '101',
    numVenda: 111,
    urlEmpreendimento: '',
    urlImg: '',
    codcoligada: 1,
  },
  {
    nomeEmpreendimento: 'Residencial Aurora',
    codEmpreendimento: 'EMP001',
    idEmpreendimento: 1,
    codUnidade: 'B2',
    unidade: 'Bloco B',
    subUnidade: '201',
    numVenda: 222,
    urlEmpreendimento: '',
    urlImg: '',
    codcoligada: 1,
  },
];

const mockBoletos: IBuscaBoletos = [
  {
    empreendimento: 'Residencial Aurora',
    idlan: 501,
    numVenda: 111,
    dataVencimento: '2026-06-10T00:00:00',
    dataVencimentoDiaUtil: '2026-06-10T00:00:00',
    valorPrincipal: 1800,
    valorAtual: 1800,
    valordevido: 1800,
    valorpago: 0,
    dataPagamento: '',
    status: 'Em Aberto',
    idBaixa: 0,
    codcoligada: 1,
  },
];

const mockFaturasVencidas: IBuscaBoletosVencidos = [
  {
    empreendimento: 'Residencial Aurora',
    idlan: 1,
    numVenda: 111,
    dataVencimento: '2026-03-10T00:00:00',
    dataVencimentoDiaUtil: '2026-03-10T00:00:00',
    valorPrincipal: 1000,
    valorAtual: 1120,
    valordevido: 1150,
    valorpago: 0,
    valorEncargo: 30,
    valorDescapitalizacao: 0,
    taxa: 0.5,
    nroPeriodo: 1,
    parcela: '1/180',
    dataPagamento: '',
    status: 'Atrasada',
    idBaixa: 0,
    codcoligada: 1,
  },
  {
    empreendimento: 'Residencial Aurora',
    idlan: 2,
    numVenda: 111,
    dataVencimento: '2026-07-10T00:00:00',
    dataVencimentoDiaUtil: '2026-07-10T00:00:00',
    valorPrincipal: 1000,
    valorAtual: 1000,
    valordevido: 1000,
    valorpago: 0,
    valorEncargo: 0,
    valorDescapitalizacao: 15,
    taxa: 0.5,
    nroPeriodo: 2,
    parcela: '2/180',
    dataPagamento: '',
    status: 'Em Aberto',
    idBaixa: 0,
    codcoligada: 1,
  },
  {
    empreendimento: 'Residencial Aurora',
    idlan: 3,
    numVenda: 111,
    dataVencimento: '2026-02-10T00:00:00',
    dataVencimentoDiaUtil: '2026-02-10T00:00:00',
    valorPrincipal: 1000,
    valorAtual: 1000,
    valordevido: 1000,
    valorpago: 1000,
    valorEncargo: 0,
    valorDescapitalizacao: 0,
    taxa: 0.5,
    nroPeriodo: 3,
    parcela: '3/180',
    dataPagamento: '2026-02-09T00:00:00',
    status: 'Quitada',
    idBaixa: 1,
    codcoligada: 1,
  },
];

const mockBoletosAvulsos: IBuscaBoletosAvulsos = [];

const mockParcelas: IBuscaParcela = [
  {
    empreendimento: 'Residencial Aurora',
    idlan: 1,
    numVenda: 111,
    dataVencimento: '2026-03-10T00:00:00',
    dataVencimentoDiaUtil: '2026-03-10T00:00:00',
    valorPrincipal: 1000,
    valorAtual: 1120,
    valordevido: 1150,
    valorpago: 0,
    valorEncargo: 30,
    valorDescapitalizacao: 0,
    dataPagamento: null,
    status: 'Atrasada',
    idBaixa: 0,
    codcoligada: 1,
  },
  {
    empreendimento: 'Residencial Aurora',
    idlan: 2,
    numVenda: 111,
    dataVencimento: '2026-07-10T00:00:00',
    dataVencimentoDiaUtil: '2026-07-10T00:00:00',
    valorPrincipal: 1000,
    valorAtual: 1000,
    valordevido: 1000,
    valorpago: 0,
    valorEncargo: 0,
    valorDescapitalizacao: 15,
    dataPagamento: null,
    status: 'Em Aberto',
    idBaixa: 0,
    codcoligada: 1,
  },
  {
    empreendimento: 'Residencial Aurora',
    idlan: 3,
    numVenda: 111,
    dataVencimento: '2026-02-10T00:00:00',
    dataVencimentoDiaUtil: '2026-02-10T00:00:00',
    valorPrincipal: 1000,
    valorAtual: 1000,
    valordevido: 1000,
    valorpago: 1000,
    valorEncargo: 0,
    valorDescapitalizacao: 0,
    dataPagamento: '2026-02-09T00:00:00',
    status: 'Quitada',
    idBaixa: 1,
    codcoligada: 1,
  },
];

export const getMockBoletos = (): IBuscaBoletos =>
  mockScenario === 'empty-boletos' ? [] : mockBoletos;

export const getMockFaturasVencidas = (): IBuscaBoletosVencidos =>
  mockScenario === 'empty-finance' ? [] : mockFaturasVencidas;

export const getMockBoletosAvulsos = (): IBuscaBoletosAvulsos =>
  mockScenario === 'empty-boletos' ? [] : mockBoletosAvulsos;

export const getMockParcelas = (): IBuscaParcela =>
  mockScenario === 'empty-finance' ? [] : mockParcelas;

export const mockIndicesIgpm: IBuscaIndices = [
  { Data: '2026-01-01T00:00:00', Indice: 'IGPM', Valor: 0.41 },
  { Data: '2026-02-01T00:00:00', Indice: 'IGPM', Valor: 0.32 },
  { Data: '2026-03-01T00:00:00', Indice: 'IGPM', Valor: 0.28 },
];

export const mockIndicesIncc: IBuscaIndices = [
  { Data: '2026-01-01T00:00:00', Indice: 'INCC', Valor: 0.45 },
  { Data: '2026-02-01T00:00:00', Indice: 'INCC', Valor: 0.39 },
  { Data: '2026-03-01T00:00:00', Indice: 'INCC', Valor: 0.36 },
];

export const mockAcompanhamento: IAcompanhamentoObra = {
  id: 1,
  codColigada: 1,
  codEmpreendimento: 1,
  Acabamento: 30,
  Revestimento: 48,
  Alvenaria: 72,
  Estrutura: 91,
  Fundacao: 100,
  PreparoTerreno: 100,
  TotalFinalizado: 74,
  DataAlteracao: '2026-05-10T00:00:00',
  PrevEntrega: '2026-12-30T00:00:00',
  UsuarioAlteracao: 'mock.user',
  Embed: '',
  Links: [
    {
      Periodo: 'Abr/2026',
      Links: [
        'https://picsum.photos/id/1018/800/500',
        'https://picsum.photos/id/1025/800/500',
      ],
    },
    {
      Periodo: 'Mai/2026',
      Links: ['https://picsum.photos/id/1040/800/500'],
    },
  ],
};

export const mockEmpreendimentosAssistencia: Empreendimento[] = [
  {
    nomeEmpreendimento: 'Residencial Aurora',
    codEmpreendimento: 'EMP001',
    idEmpreendimento: 1,
    codUnidade: 'B1',
    unidade: 'Bloco A',
    subUnidade: '101',
  },
  {
    nomeEmpreendimento: 'Residencial Aurora',
    codEmpreendimento: 'EMP001',
    idEmpreendimento: 1,
    codUnidade: 'B2',
    unidade: 'Bloco B',
    subUnidade: '201',
  },
];

export const mockContratos: IDownloadContratos = [
  {
    nome: 'Contrato_Residencial_Aurora',
    descricao: 'Contrato de compra e venda',
    empreendimento: 'Residencial Aurora',
    binDocumento: 'JVBERi0xLjQKJcTl8uXr',
  },
];

const mockDownloads: IDownloadDocumentos = [
  {
    id: 1,
    id_empreendimento: 1,
    descricao: 'Manual do proprietario',
    nomeArquivoExibicao: 'Manual_Proprietario.pdf',
    nomeArquivo: '/docs/manual-proprietario.pdf',
    dtInicial: '2026-01-01T00:00:00',
    dtFinal: '2026-12-31T00:00:00',
    empreendimento: 'Residencial Aurora',
    unidade: 'Bloco A',
    subunidade: '101',
  },
];

export const getMockDownloads = (): IDownloadDocumentos =>
  mockScenario === 'empty-docs' ? [] : mockDownloads;

export const mockDadosVenda = {
  idlan: 1,
  numVenda: 111,
  dataVenda: '2025-01-15T00:00:00',
  bloco: 'Bloco A',
  unidade: '101',
  empreendimento: 'Residencial Aurora',
  cliente: 'Cliente Demo',
  conjuge: '',
  valorVenda: 285000,
  percentualPago: 35,
  percentualDevido: 65,
  status: null,
};
